export class CompanyPayingConfiguration {
    public employeesUrl: string;
    public checkoutUrl: string;

    constructor(private container: JQuery) {
        const baseUrl = container.attr('data-api-root-prefix');
        this.employeesUrl = baseUrl + container.attr('data-employees-api-url');
        this.checkoutUrl = baseUrl + container.attr('data-checkout-api-url');
    }
}
